import React, { useState, useEffect } from 'react';
import SharedHelmet from "../Helmet";
import { FirstAds, SecondAds } from "../../Ads";
import imageUrl from "../../../images/eid-adha.webp";
import BlinkingText from '../../BlinkingText';
import RelatedLinks from '../RelatedLinks';
import MainCalculatorsList from './MainCalculators';
const TITLE = "Berapa Hari Lagi Tahun Baru Hijriah 2026 - Hitung Mundur Tahun Baru Hijriah";
const DESCRIPTION = "Berapa hari lagi Tahun Baru Hijriah 1446, jadwal Tahun Baru Hijriah 1446, kapan Tahun Baru Hijriah, tanggal Tahun Baru Hijriah 1446, kapan Tahun Baru Hijriah 1446, perayaan Tahun Baru Hijriah, ucapan Tahun Baru Hijriah, berapa hari lagi Tahun Baru Hijriah 1446, tanggal Tahun Baru Hijriah, Tahun Baru Hijriah dalam kalender Hijriah, kapan Tahun Baru Hijriah 1446, amalan Tahun Baru Hijriah, berapa hari lagi Tahun Baru Hijriah, Tahun Baru Hijriah 1446 H, berapa hari lagi Tahun Baru Islam 1446, tanggal Tahun Baru Hijriah, kapan Tahun Baru Hijriah tahun ini, perayaan Tahun Baru Hijriah, jadwal Tahun Baru Hijriah 2026";
const KEYWORDS = "berapa hari lagi Tahun Baru Hijriah 1446, jadwal Tahun Baru Hijriah 1446, kapan Tahun Baru Hijriah, tanggal Tahun Baru Hijriah 1446, kapan Tahun Baru Hijriah 1446, perayaan Tahun Baru Hijriah, berapa hari lagi Tahun Baru Hijriah 1446, hitung mundur Tahun Baru Hijriah, 1 Muharram 2026, Tahun Baru Islam 2026";
const OG_URL = "https://do-calculate.com/articles-id/hijri/";
function RaasSanaHijriya() {
    const calculateTimeLeft = (targetDate) => {
        const now = new Date();
        const difference = targetDate - now;
        let timeLeft = {};
        if (difference > 0) {
            timeLeft = {
                days: Math.floor(difference / (1000 * 60 * 60 * 24)),
                hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
                minutes: Math.floor((difference / 1000 / 60) % 60),
                seconds: Math.floor((difference / 1000) % 60)
            };
        }
        return timeLeft;
    };
    const initialDate = new Date("2026-06-27T00:00:00");
    const [timeLeft, setTimeLeft] = useState(calculateTimeLeft(initialDate));
    useEffect(() => {
        const timer = setTimeout(() => {
            setTimeLeft(calculateTimeLeft(initialDate));
        }, 1000);
        return () => clearTimeout(timer);
    }, [timeLeft]);
    const hijriDates = [
        { name: 'Tahun Baru Hijriah 2026', date: new Date("2026-06-27T00:00:00") },
        { name: 'Tahun Baru Hijriah 2026', date: new Date("2026-06-17T00:00:00") },
        { name: 'Tahun Baru Hijriah 2027', date: new Date("2027-06-06T00:00:00") },
        { name: 'Tahun Baru Hijriah 2028', date: new Date("2028-05-25T00:00:00") },
        { name: 'Tahun Baru Hijriah 2029', date: new Date("2029-05-15T00:00:00") },
    ];
    return (
        <div className="ltr">
            <SharedHelmet
                TITLE={TITLE}
                DESCRIPTION={DESCRIPTION}
                KEYWORDS={KEYWORDS}
                OG_URL={OG_URL}
            />
            <div className="row">
                <FirstAds />
            </div>
            <h1 className='p-3 mb-2 bg-success text-white'>
                Berapa Hari Lagi Tahun Baru Hijriah 1446
            </h1>
            <div>
                <BlinkingText text="Berapa hari lagi Tahun Baru Hijriah 1446: Diperkirakan Tahun Baru Hijriah 1446 dimulai hari Jumat tanggal 27/06/2027 Masehi dan 01 Muharram 1446 menurut kalender Hijriah." />
            </div>
            <div className="row">
                <div id="timer" style={{ width: '100%', fontSize: '40px' }}>
                    <table style={{ width: '100%', textAlign: 'center', borderCollapse: 'collapse', border: '1px solid #ccc', fontSize: '24px' }}>
                        <thead>
                            <tr>
                                <th>Hari</th>
                                <th>Jam</th>
                                <th>Menit</th>
                                <th>Detik</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td id="days">{timeLeft.days}</td>
                                <td id="hours">{timeLeft.hours}</td>
                                <td id="minutes">{timeLeft.minutes}</td>
                                <td id="seconds">{timeLeft.seconds}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div className="row">
                <SecondAds />
            </div>
            <div className="row">
                <div className="col-12 col-md-8">
                    <div>
                        <h2 className='p-3 mb-2 bg-success text-white' style={{ color: '#333', fontSize: '36px', textAlign: 'center' }}>Jadwal Tahun Baru Hijriah Mendatang</h2>
                        <table style={{ fontSize: '24px', width: '100%', textAlign: 'center', borderCollapse: 'collapse', border: '2px solid #ccc', borderRadius: '8px', overflow: 'hidden' }}>
                            <thead>
                                <tr style={{ backgroundColor: '#f2f2f2' }}>
                                    <th style={{ padding: '16px', borderBottom: '2px solid #ccc' }}>Jadwal Tahun Baru Hijriah</th>
                                    <th style={{ padding: '16px', borderBottom: '2px solid #ccc' }}>Tanggal</th>
                                    <th style={{ padding: '16px', borderBottom: '2px solid #ccc' }}>Sisa Hari</th>
                                </tr>
                            </thead>
                            <tbody>
                                {hijriDates.map((date, index) => (
                                    <tr key={index} style={{ backgroundColor: index % 2 === 0 ? '#fff' : '#f9f9f9' }}>
                                        <td style={{ padding: '12px' }}>{date.name}</td>
                                        <td style={{ padding: '12px' }}>{date.date.toLocaleDateString('en-GB')}</td>
                                        <td style={{ padding: '12px' }}>{calculateTimeLeft(date.date).days} hari</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="col">
                    <MainCalculatorsList />
                </div>
            </div>
            <div className="row">
                <div className="col-12 col-md-8">
                    <h3 className='p-3 mb-2 bg-success text-white'>Berapa Hari Lagi Tahun Baru Hijriah</h3>
                    <p>
                        Dalam artikel ini, kami menyajikan hitung mundur lengkap menuju Tahun Baru Hijriah, agar Anda selalu mengetahui berapa hari lagi peristiwa keagamaan ini tiba. Banyak di antara kita yang bertanya berapa hari lagi Tahun Baru Hijriah, oleh karena itu kami hadirkan hitung mundur Tahun Baru Hijriah agar Anda dapat mengetahui berapa hari lagi Tahun Baru Hijriah, berapa hari tersisa hingga Tahun Baru Hijriah. Lihat hitung mundur Tahun Baru Hijriah di atas.
                    </p>
                    <p>
                        Berdasarkan situs <a href='/calculator/id/gregorian_to_hijri/'>konversi tanggal</a>, Tahun Baru Hijriah 1446 bertepatan dengan hari Jumat tanggal 27/06/2027 Masehi dan 01 Muharram 1446 Hijriah. Anda dapat melihat hitung mundur Tahun Baru Hijriah 1446 di artikel ini.
                    </p>
                    <p>Temukan di sini hitung mundur Tahun Baru Hijriah, di mana Anda dapat mengetahui berapa hari lagi Tahun Baru Hijriah.
                    </p>
                    <hr />
                    <RelatedLinks />
                    <hr />
                    <h3 className='p-3 mb-2 bg-success text-white'>
                        Hitung Berapa Hari Lagi Tahun Baru Hijriah
                    </h3>
                    <p>
                        Melalui program hitung mundur Tahun Baru Hijriah, Anda dapat mengetahui berapa hari lagi Tahun Baru Hijriah dalam kalender Masehi maupun Hijriah, serta mengetahui sisa hari menuju Tahun Baru Hijriah, kapan Tahun Baru Hijriah tiba, dan jadwal Tahun Baru Hijriah yang mulia tahun ini. Semoga Allah melimpahkan keberkahan kepada kita semua di tahun baru yang penuh makna ini.
                    </p>
                    <h3 className='p-3 mb-2 bg-success text-white'>
                        Tahun Baru Hijriah
                    </h3>
                    <p>
                        Tahun Baru Hijriah adalah awal tahun baru dalam kalender Islam, dan umat Muslim merayakannya pada hari pertama bulan Muharram setiap tahun Hijriah. Hari ini dianggap sebagai salah satu momen keagamaan penting yang diperingati umat Muslim dengan doa, perenungan atas tahun yang telah berlalu, dan perencanaan untuk tahun yang akan datang. Hari ini memiliki arti khusus dalam sejarah Islam karena melambangkan Hijrah Nabi dari Mekah ke Madinah, yang menjadi titik awal penanggalan Islam.
                    </p>
                    <div>
                        <br />
                        <img src={imageUrl} alt="Berapa hari lagi Tahun Baru Hijriah 2026"
                            width="800"
                            height="450"
                            style={{ width: '100%', height: 'auto', maxWidth: '800px' }}
                            loading="lazy"
                        />
                        <br />
                    </div>
                </div>
            </div>
        </div>
    );
}
export default RaasSanaHijriya;
